<template>
    <div class="flex flex-col">
      <div class="grid grid-cols bg-backgroundG">
        <div class="card px-1 md:px-[15%] md:rounded-b-[12px]">
          <p class="text-lg md:text-[28px] font-bold leading-8 mb-[80px] text-center">
            What is your desired outcome from this campaign?
          </p>

          <div class="mb-[73px]">
            <div class="flex flex-col px-4 md:px-0 md:flex-row gap-5 justify-center">
              <button
                class="card shadow-md text-center rounded-[8px] w-full md:max-w-[373px] max-h-[150px] text-[18px] font-semibold"
                :class="[
                  stepOn.advertisingGoal == 'Awareness'
                    ? 'bg-primary text-white'
                    : '',
                ]"
                @click="selectedGaolButton('Awareness')"
                value="Awareness"
                type="button"
                @blur="markTouched('Awareness')"
              >
                Awareness <br />
                <span class="text-[14px] font-normal h-0"
                  >Reach millions of people on the streets every day</span
                >
              </button>
              <button
                class="card shadow-md text-center rounded-[8px] w-full md:max-w-[373px] text-[18px] font-semibold"
                :class="[
                  stepOn.advertisingGoal == 'Conversions'
                    ? 'bg-primary text-white'
                    : '',
                ]"
                @click="selectedGaolButton('Conversions')"
                value="Conversions"
                type="button"
                @blur="markTouched('Conversions')"
              >
                Conversions <br />
                <span class="text-[14px] font-normal h-0"
                  >Track your conversions in real-time</span
                >
              </button>
            </div>
            <p
              class="flex flex-row justify-center text-red-400 text-[14px] pt-1"
              v-if="emptyAdvertisingGoal"
            >
              This field is required
            </p>
          </div>
          <div class="flex gap-6 flex-col px-3 md:px-0 md:flex-row">
            <div class="flex flex-col w-full">
              <span class="font-bold mb-2">Campaign Name</span>
              <input
                class="block pl-4 bg-inputbg rounded-[5px] h-14 py-2 text-black focus:outline-primary focus:bg-white"
                :class="[emptyCampaignTitle ? 'border-2 border-red-500 ' : '']"
                type="text"
                placeholder="Campaign Name"
                v-model="stepOn.campaignTitle"
                required
                @blur="markTouched('campaignTitle')"
              />
              <p v-if="emptyCampaignTitle" class="text-red-400 text-[14px] pt-1">
                This field is required
              </p>
            </div>
            <div class="flex md:hidden flex-col w-full">
              <span class="font-semibold mb-2">Campaign Duration</span>
              <form class="w-full" @submit.prevent>
                  <div class="">
                    <v-date-picker
                      v-model="stepTh.duration"
                      mode="date"
                      :masks="masks"
                      is-range
                      :model-config="modelConfig"
                      :minDate="settDate"
                      :class="[emptyEndDate ? 'border-2 border-red-400' : '']"
                      @blur="markTouched('durationEnd')"
                    >
                      <template v-slot="{ inputValue, inputEvents, isDragging }">
                        <div
                          class="flex flex-col sm:flex-row justify-start items-center"
                        >
                          <div class="relative flex-grow w-full">
                            <svg
                              class="text-gray-600 w-4 h-full mx-2 absolute pointer-events-none"
                              fill="none"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                              ></path>
                            </svg>
                            <input
                              class="flex-grow pl-8 pr-2 py-1 h-14 bg-gray-100 border rounded w-full focus:outline-primary focus:bg-white"
                              :class="[
                                isDragging ? 'text-gray-600' : 'text-gray-900',
                              ]"
                              :value="inputValue.start"
                              v-on="inputEvents.start"
                              placeholder="Start date:"
                              @change="updateDuration"
                              @blur="markTouched('durationStart')"
                            />
                          </div>
                          <span class="flex-shrink-0 m-2">
                            <svg
                              class="w-4 h-4 stroke-current text-gray-600"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M14 5l7 7m0 0l-7 7m7-7H3"
                              />
                            </svg>
                          </span>
                          <div class="relative flex-grow w-full">
                            <svg
                              class="text-gray-600 w-4 h-full mx-2 absolute pointer-events-none"
                              fill="none"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                              ></path>
                            </svg>
                            <input
                              class="flex-grow pl-8 pr-2 py-1 h-14 bg-gray-100 border rounded w-full focus:outline-primary focus:bg-white"
                              :class="[
                                isDragging ? 'text-gray-600' : 'text-gray-900',
                                emptyEndDate ? 'border-2 border-red-500' : ''
                              ]"
                              placeholder="End date:"
                              :value="inputValue.end"
                              v-on="inputEvents.end"
                              @change="updateDuration"
                              @blur="markTouched('durationEnd')"
                            />
                          </div>
                        </div>
                      </template>
                    </v-date-picker>
                    <p v-if="emptyEndDate" class="text-red-400 text-[14px] pt-1">
                      Please select an end date.
                    </p>
                  </div>
                </form>
            </div>

            <div class="flex gap-1 mb-6 flex-col w-full px-1">
              <span class="font-semibold mb-2">Daily Budget</span>
              <div class="flex items-center gap-1 content-between w-full">
                <div class="flex flex-col items-center w-full mx-auto">
                  <div class="flex items-center content-center w-full">
                    <!-- Minimum Value -->
                    <div
                      class="text-black flex text-sm md:text-lg w-24 sm:w-28 md:w-32 lg:w-36 xl:w-40 p-2 sm:p-3 rounded-md bg-lightTeal"
                    >
                      <span class="text-grey-300 ml-1">{{ stepThBudget }} </span>
                      <span class="text-primary ml-1">
                        {{
                          $store.state.auth.country_code === "EG" ? "EGP" : "SAR"
                        }}</span
                      >
                    </div>

                    <!-- Slider -->
                    <input
                      type="range"
                      :min="minBudget"
                      :max="maxBudget"
                      :step="budgetSliderStep"
                      v-model="stepThBudget"
                      @change="updateCars"
                      class="budget-range mx-4 h-2 bg-gray-300 rounded-lg"
                      @blur="markTouched('budget')"
                    />
                    <!-- Maximum Value -->
                    <div
                      class="text-black flex text-sm md:text-lg w-24 sm:w-28 md:w-32 lg:w-36 xl:w-40 p-2 sm:p-3 rounded-md bg-lightTeal"
                    >
                      <span class="text-grey-300 ml-1">{{ maxBudget }}</span>
                      <span class="text-primary ml-1">
                        {{
                          $store.state.auth.country_code === "EG" ? "EGP" : "SAR"
                        }}</span
                      >
                    </div>
                  </div>
                </div>
                <!-- <span
                  v-if="stepTh.budget"
                  class="text-primary font-semibold text-[18px]"
                  >{{
                    $store.state.auth.country_code === "EG" ? "EGP" : "SAR"
                  }}</span
                > -->
              </div>
              <p v-if="emptyBudget" class="text-red-400 text-[14px] p-0">
                Minimum of {{ minBudget }} / Month
              </p>
              <p v-if="exceedsMaxBudget" class="text-red-400 text-[14px] pt-1">
                Budget exceeds the maximum allowed value, maximum of
                {{ maxBudget }} / Month
              </p>
            </div>
            <div v-if="!this.$store.state.auth.country_code === 'EG'" class="flex md:hidden gap-1 mb-6 flex-col w-full">
              <span class="font-semibold mb-2">Assigned Cars</span>
              <div class="flex items-center gap-1 content-between w-full">
                <div class="flex flex-col items-center w-full mx-auto">
                  <div class="flex items-center content-center w-full">
                    <div
                      class="text-black flex text-sm md:text-lg w-24 sm:w-28 md:w-32 lg:w-36 xl:w-40 p-2 sm:p-3 rounded-md bg-lightTeal"
                    >
                      <span class="text-grey-300 ml-1">{{ assignedCars }} </span>
                      <span class="text-primary ml-1">Car(s)</span>
                    </div>

                    <!-- Slider -->
                    <input
                      type="range"
                      :min="minAssignedCars"
                      :max="maxAssignedCars"
                      step=1
                      v-model="assignedCars"
                      class="budget-range mx-4 h-2 bg-gray-300 rounded-lg"
                      @change="updateBudget"
                      />
                    <!-- Maximum Value -->
                    <div
                      class="text-black flex text-sm md:text-lg w-24 sm:w-28 md:w-32 lg:w-36 xl:w-40 p-2 sm:p-3 rounded-md bg-lightTeal"
                    >
                      <span class="text-grey-300 ml-1">{{ maxAssignedCars }}</span>
                      <span class="text-primary ml-1">Cars</span>
                    </div>
                  </div>
                </div>
                <!-- <span
                  v-if="stepTh.budget"
                  class="text-primary font-semibold text-[18px]"
                  >{{
                    $store.state.auth.country_code === "EG" ? "EGP" : "SAR"
                  }}</span
                > -->
              </div>
              <p v-if="emptyBudget" class="text-red-400 text-[14px] p-0">
                Minimum of {{ minBudget }} / Month
              </p>
              <p v-if="exceedsMaxBudget" class="text-red-400 text-[14px] pt-1">
                Budget exceeds the maximum allowed value, maximum of
                {{ maxBudget }} / Month
              </p>
            </div>
          </div>

          <div class="hidden md:flex gap-6 flex-col px-4 md:px-0 md:flex-row">
            <div class="flex flex-col w-full">
              <span class="font-semibold mb-2">Campaign Duration</span>
              <form class="w-full" @submit.prevent>
                  <div class="flex w-full justify-between items-center">
                    <v-date-picker
                      v-model="stepTh.duration.start"
                      mode="date"
                      :masks="masks"
                      :model-config="modelConfig"
                      :minDate="settDate"
                      @blur="markTouched('durationStart')"
                      @update:modelValue="updateEndDate"
                    >
                      <template v-slot="{ inputValue, inputEvents, isDragging }">
                      <div
                        class="flex flex-col sm:flex-row justify-start items-center"
                      >
                        <div class="relative flex-grow w-full">
                        <svg
                          class="text-gray-600 w-4 h-full mx-2 absolute pointer-events-none"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          ></path>
                        </svg>
                        <input
                          class="flex pl-8 pr-2 py-1 h-14 bg-gray-100 border rounded w-full focus:outline-primary focus:bg-white"
                          :class="
                          isDragging ? 'text-gray-600' : 'text-gray-900'
                          "
                          :value="inputValue"
                          v-on="inputEvents"
                          placeholder="Select date:"
                        />
                        </div>
                      </div>
                      </template>
                    </v-date-picker>
                    <span class="flex-shrink-0 m-2">
                      <svg
                        class="w-4 h-4 stroke-current text-gray-600"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                      </svg>
                    </span>
                    <v-date-picker
                      v-model="stepTh.duration.end"
                      mode="date"
                      :masks="masks"
                      :model-config="modelConfig"
                      :minDate="endDateMinimum"
                      :disabled="endDateDisabled"
                      :class="[emptyEndDate ? 'border-2 border-red-400' : '']"
                      @blur="markTouched('durationEnd')"
                    >
                     <template v-slot="{ inputValue, inputEvents, isDragging }">
                      <div
                        class="flex flex-col sm:flex-row justify-start items-center"
                      >
                        <div class="relative flex-grow w-full">
                        <svg
                          class="text-gray-600 w-4 h-full mx-2 absolute pointer-events-none"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          ></path>
                        </svg>
                        <input
                          class="flex-grow pl-8 pr-2 py-1 h-14 bg-gray-100 border rounded w-full focus:outline-primary focus:bg-white"
                          :class="[
                          isDragging ? 'text-gray-600' : 'text-gray-900'
                          ]"
                          :value="inputValue"
                          v-on="inputEvents"
                          placeholder="Select date:"
                        />
                        </div>
                      </div>
                      </template>
                    </v-date-picker>
                  </div>
                   <!-- Add validation message for desktop -->
                  <p v-if="emptyEndDate" class="text-red-400 text-[14px] pt-1 text-center mt-1">
                      Please select an end date.
                  </p>
                </form>
            </div>
            <div v-if="this.$store.state.auth.country_code === 'SA'" class="hidden md:flex gap-1 mb-6 flex-col w-full">
              <span class="font-semibold mb-2">Assigned Cars</span>
              <div class="flex items-center gap-1 content-between w-full">
                <div class="flex flex-col items-center w-full mx-auto">
                  <div class="flex items-center content-center w-full">
                    <div
                      class="text-black flex text-sm md:text-lg w-24 sm:w-28 md:w-32 lg:w-36 xl:w-40 p-2 sm:p-3 rounded-md bg-lightTeal"
                    >
                      <span class="text-grey-300 ml-1">{{ assignedCars }} </span>
                      <span class="text-primary ml-1">Car(s)</span>
                    </div>

                    <!-- Slider -->
                    <input
                      type="range"
                      :min="minAssignedCars"
                      :max="maxAssignedCars"
                      step=1
                      v-model="assignedCars"
                      class="budget-range mx-4 h-2 bg-gray-300 rounded-lg"
                      @change="updateBudget"
                      />
                    <!-- Maximum Value -->
                    <div
                      class="text-black flex text-sm md:text-lg w-24 sm:w-28 md:w-32 lg:w-36 xl:w-40 p-2 sm:p-3 rounded-md bg-lightTeal"
                    >
                      <span class="text-grey-300 ml-1">{{ maxAssignedCars }}</span>
                      <span class="text-primary ml-1">Cars</span>
                    </div>
                  </div>
                </div>
                <!-- <span
                  v-if="stepTh.budget"
                  class="text-primary font-semibold text-[18px]"
                  >{{
                    $store.state.auth.country_code === "EG" ? "EGP" : "SAR"
                  }}</span
                > -->
              </div>
              <p v-if="emptyBudget" class="text-red-400 text-[14px] p-0">
                Minimum of {{ minBudget }} / Month
              </p>
              <p v-if="exceedsMaxBudget" class="text-red-400 text-[14px] pt-1">
                Budget exceeds the maximum allowed value, maximum of
                {{ maxBudget }} / Month
              </p>
            </div>
          </div>
          <!-- <p v-if="eempty" class="text-red-300 text-[14px] pt-1 text-center">
            This field is required
          </p> -->
          <div class="grid grid-cols">
            <div class="card w-[70%] m-auto mt-5 md:mt-[73px] rounded-[8px] shadow-lg">
              <div class="flex justify-evenly items-center flex-wrap gap-4">
                <div class="flex flex-col">
                  <div class="flex flex-col items-center justify-between">
                    <!-- <img src="../../assets/SVGs/Eye.svg" > -->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                    >
                      <g id="Impressions" transform="translate(0)">
                        <circle
                          id="Ellipse_1163"
                          data-name="Ellipse 1163"
                          cx="18"
                          cy="18"
                          r="18"
                          transform="translate(0)"
                          fill="none"
                        />
                        <g id="eye" transform="translate(8.174 10.351)">
                          <path
                            id="Path_25818"
                            data-name="Path 25818"
                            d="M19.047,8.192A10.84,10.84,0,0,0,9.822,2.655,10.84,10.84,0,0,0,.6,8.192a4.017,4.017,0,0,0,0,4.225,10.84,10.84,0,0,0,9.226,5.537,10.84,10.84,0,0,0,9.226-5.537A4.017,4.017,0,0,0,19.047,8.192Zm-1.4,3.368a9.261,9.261,0,0,1-7.83,4.757,9.261,9.261,0,0,1-7.83-4.757,2.388,2.388,0,0,1,0-2.511,9.261,9.261,0,0,1,7.83-4.757,9.254,9.254,0,0,1,7.83,4.757A2.388,2.388,0,0,1,17.652,11.56Z"
                            transform="translate(0.004 -2.655)"
                          />
                          <path
                            id="Path_25819"
                            data-name="Path 25819"
                            d="M11.093,7a4.093,4.093,0,1,0,4.093,4.093A4.093,4.093,0,0,0,11.093,7Zm0,6.548a2.456,2.456,0,1,1,2.456-2.456A2.456,2.456,0,0,1,11.093,13.548Z"
                            transform="translate(-1.267 -3.443)"
                          />
                        </g>
                      </g>
                    </svg>

                    <p class="text-[18] font-semibold flex">
                      Impressions
                    </p>
                  </div>
                  <p class="text-[16px] text-primary flex justify-center">
                    {{ impressions }}
                    <!-- 170k - 150k -->
                  </p>
                </div>
                <div class="flex flex-col">
                  <div class="flex flex-col items-center justify-between">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                    >
                      <g
                        id="Group_16535"
                        data-name="Group 16535"
                        transform="translate(-989 -145)"
                      >
                        <path
                          id="Path_25871"
                          data-name="Path 25871"
                          d="M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z"
                          transform="translate(989 145)"
                          fill="none"
                          opacity="0.3"
                        />
                        <g
                          id="_01_align_center"
                          data-name="01 align center"
                          transform="translate(998.2 154.2)"
                        >
                          <path
                            id="Path_26110"
                            data-name="Path 26110"
                            d="M8.8,1.467a7.357,7.357,0,0,1,5.223,2.2H11V5.133h3.772a1.363,1.363,0,0,0,1.362-1.362V0H14.667V2.257A8.787,8.787,0,0,0,0,8.8H1.467A7.342,7.342,0,0,1,8.8,1.467Z"
                          />
                          <path
                            id="Path_26111"
                            data-name="Path 26111"
                            d="M16.667,12A7.323,7.323,0,0,1,4.111,17.133H7.133V15.667H3.362A1.363,1.363,0,0,0,2,17.029V20.8H3.467V18.543A8.787,8.787,0,0,0,18.134,12Z"
                            transform="translate(-0.533 -3.2)"
                          />
                        </g>
                      </g>
                    </svg>

                    <p class="text-[18] font-semibold flex justify-center">
                      Ad Loops
                    </p>
                  </div>
                  <p class="text-[16px] text-primary flex justify-center">
                    {{ ad_loops }}
                  </p>
                </div>
                <div class="flex flex-col">
                  <div
                    class="flex flex-col items-center justify-center text-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                    >
                      <g
                        id="Distance_Covered"
                        data-name="Distance Covered"
                        transform="translate(0)"
                      >
                        <path
                          id="Path_25871"
                          data-name="Path 25871"
                          d="M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z"
                          transform="translate(0)"
                          fill="none"
                          opacity="0.3"
                        />
                        <path
                          id="tachometer-slow"
                          d="M16.773,17.83a2.473,2.473,0,0,1-3.341.105l-.842-.728a.821.821,0,0,1,1.073-1.242l.843.728a.82.82,0,0,0,1.112-.03A8.2,8.2,0,1,0,4.04,16.632a.833.833,0,0,0,1.144.062l.843-.729A.821.821,0,1,1,7.1,17.207l-.842.728a2.494,2.494,0,0,1-3.38-.144,9.845,9.845,0,1,1,13.894.038ZM9.845,9.2a1.648,1.648,0,0,0-.425.056l-3.1-3.1a.82.82,0,1,0-1.16,1.16l3.1,3.1A1.641,1.641,0,1,0,9.845,9.2Z"
                          transform="translate(8.152 8.234)"
                        />
                      </g>
                    </svg>

                    <p class="text-[18] font-semibold flex justify-center">
                      Minutes
                    </p>
                  </div>
                  <p class="text-[16px] text-primary flex justify-center">
                    {{ minutes }}
                  </p>
                </div>
                <div class="flex flex-col">
                  <div
                    class="flex flex-col items-center justify-center text-center"
                  >
                  <img src="../../assets/calendar.png" class="w-6 h-auto py-1.5" />

                    <p class="text-[18] font-semibold flex justify-center">
                      Days
                    </p>
                  </div>
                  <p class="text-[16px] text-primary flex justify-center">
                    {{ Days }}
                  </p>
                </div>
                <div class="flex flex-col">
                  <div
                    class="flex flex-col h-full items-center justify-center text-center"
                  >
                    <img src="../../assets/dollar-currency.svg" class="w-7 h-auto py-1" />

                    <p class="text-[18] font-semibold flex justify-center">
                      Budget
                    </p>
                  </div>
                  <p class="text-[16px] text-primary flex justify-center">
                    {{ budget }}
                  </p>
                </div>
                <div v-if="this.$store.state.auth.country_code === 'SA'" class="flex flex-col">
                  <div
                    class="flex flex-col items-center justify-center text-center"
                  >
                  <img src="../../assets/car-icon.png" class="w-7 h-auto py-1" />

                    <p class="text-[18] font-semibold flex justify-center">
                      Assigned Cars
                    </p>
                  </div>
                  <p class="text-[16px] text-primary flex justify-center">
                    {{ cars }}
                  </p>
                </div>
              </div>
            </div>
            <div class="flex gap-2 flex-row-reverse mt-4">
              <button
                class="bg-primary p-2 px-[66px] rounded-[5px] text-white"
                @click="next()"
                v-if="$store.state.step < 4"
              >
                Next
              </button>
              <button
                class="bg-primary p-2 px-[66px] rounded-[5px] text-white"
                v-if="$store.state.step == 4"
              >
                Submit
              </button>
              <button
                class="bg-white p-2 px-[66px] rounded-[5px] text-primary border-2 border-primary"
                @click="back()"
                v-if="$store.state.step > 1"
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>

  import { mapGetters } from "vuex";
  import store from "../../store";
  import { calculateDaysDifference, calculateDaysDifferenceWithoutAbs, formatNumber } from "../../utils";

  // Helper function to format Date to YYYY-MM-DD
  function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  export default {
    data() {
      // Calculate date 7 days from now
      const startDateDefault = new Date();
      startDateDefault.setDate(startDateDefault.getDate() + 7);

      return {
        masks: {
          input: "YYYY-MM-DD",
        },
        stepThBudget: this.$store.state.auth.country_code === "EG" ? "1000" : "36",
        // timezone: "12 AM",
        modelConfig: {
          start: {
            timeAdjust: "00:00:00",
          },
          end: {
            timeAdjust: "00:00:00",
          },
        },
        stepOn: {
          advertisingGoal: null,
          campaignTitle: "",
          companyName: null,
        },
        stepTh: {
          duration: {
              start: startDateDefault, // Initialize start date to 7 days from now
              end: null
          },
          // budget is handled separately
        },
        minBudget: this.$store.state.auth.country_code === "EG" ? 1000 : 36,
        maxBudget:
          this.$store.state.auth.country_code === "EG" ? 5000 :360,
        budgetSliderStep: this.$store.state.auth.country_code === "EG" ? 1000 :36,
        minAssignedCars: 1,
        maxAssignedCars: 10,
        endDateMinimum: new Date(new Date().setDate(new Date().getDate() + 8)),
        endDateDisabled: true,
        assignedCars: this.$store.state.auth.country_code === "EG" ? 1 : 0,
        touched: {
          advertisingGoal: false,
          campaignTitle: false,
          budget: false,
          durationStart: false,
          durationEnd: false,
        },
      };
    },
    created() {
    },
    mounted() {
      // --- Default Advertising Goal Logic (keep as is) ---
      if (!this.step_one.advertisingGoal) {
          this.$store.commit("updataStepO", {
              ...this.step_one,
              advertisingGoal: 'Awareness'
          });
      }
      this.stepOn = { ...this.step_one };
      // --- End Default Advertising Goal Logic ---

      // Load state from store, potentially overriding defaults
      const storedDuration = this.step_three.duration;
      const storedBudget = this.step_three.budget;
      const defaultBudget = this.$store.state.auth.country_code === "EG" ? "1000" : "36";

      // Only override default duration if store has valid start/end dates
      if (storedDuration && storedDuration.start && storedDuration.end) {
          // Ensure we are assigning Date objects if stored values are strings
          this.stepTh.duration.start = new Date(storedDuration.start);
          this.stepTh.duration.end = new Date(storedDuration.end);
      } else if (storedDuration && storedDuration.start) {
          // If only start date exists in store, keep it and keep default end (null)
          this.stepTh.duration.start = new Date(storedDuration.start); // Ensure it's a Date object
          this.stepTh.duration.end = null; // Ensure end is null if not in store
      } else {
          // Otherwise, keep the default Date object set in data()
      }

      this.stepThBudget = storedBudget || defaultBudget;
      this.assignedCars = this.assignedCarsState || (this.$store.state.auth.country_code === "EG" ? 1 : 0);

      //Change Document Title
      document.title = "dKilo Ad Manager - Campaign Info";

      // Initialize touched status if resuming
      // Only mark fields as touched if they actually have restored data
      this.touched = {
          advertisingGoal: !!this.stepOn.advertisingGoal, // True if value exists
          campaignTitle: !!this.stepOn.campaignTitle, // True if value exists
          budget: !!storedBudget, // True if value exists
          durationStart: !!(storedDuration && storedDuration.start), // True if value exists
          durationEnd: !!(storedDuration && storedDuration.end) // True if value exists
      };
    },
    computed: {
      ...mapGetters(["step_one"]),
      ...mapGetters(["step_two"]),
      ...mapGetters(["step_three"]),
      ...mapGetters(["assignedCarsState"]),

      emptyAdvertisingGoal() {
        return !this.stepOn.advertisingGoal && this.touched.advertisingGoal;
      },
      emptyCampaignTitle() {
        return !this.stepOn.campaignTitle && this.touched.campaignTitle;
      },
      emptyBudget() {
        return (
          this.touched.budget &&
          (!this.stepThBudget ||
            this.stepThBudget.replace(/\D/g, "") < this.minBudget)
        );
      },
      exceedsMaxBudget() {
        if (!this.stepThBudget) {
          return false;
        }

        // Remove commas from budget and convert to number
        const numericBudget = Number(this.stepThBudget.replace(/,/g, ""));

        return this.touched.budget && numericBudget > this.maxBudget;
      },
      emptyEndDate() {
        return !this.stepTh.duration.end && this.touched.durationEnd;
      },
      isFormValid() {
        return (
          !this.emptyAdvertisingGoal &&
          !this.emptyCampaignTitle &&
          !this.emptyBudget &&
          !this.emptyEndDate
        );
      },
      ...mapGetters(["step_three"]),
      settDate() {
        const date = new Date();

        date.setDate(date.getDate() + 7);
        return date;
      },
      settDateEnd(){
        const date = new Date();

        date.setDate(date.getDate() + 8);
        return date;
      },
      formattedBudget: {
        get() {
          const currencySymbol =
            localStorage.getItem("country_code") === "EG" ? "EGP" : "SAR";
          return `${currencySymbol} ${this.stepThBudget}`;
        },
        set(value) {
          // If you need to parse the value, you can handle it here
          this.stepThBudget = value;
        },
      },

      impressions() {

        const countryCode = localStorage.getItem("country_code");
        let impressionsValue;
        // Convert budget to number, ensuring it's a valid number
        const budget = parseFloat(this.stepThBudget);

        if (isNaN(budget) || budget <= 0) {
        return "-";
        }

        // Calculate total impressions based on country
        if (countryCode === "EG") {
        const costPerImpression = 0.09;
        impressionsValue = budget / costPerImpression;
        } else if (countryCode.toLowerCase() === "sa") {
        // Calculate adLoop first
        const adLoop = budget / 0.6; // Based on your ad_loops computation
        impressionsValue = adLoop * 25;
        } else {
        return "-"; // Invalid country code
        }

        if (isNaN(impressionsValue) || impressionsValue <= 0) {
        return "-";
        }

        // Calculate min/max range (±20%)
        const minImpressions = Math.round(impressionsValue * 0.8);
        const maxImpressions = Math.round(impressionsValue * 1.2);

        // Format numbers to K or million
        const formatNumber = (num) => {
        if (num >= 1e6) {
          return `${(num / 1e6).toFixed(1)} million`;
        }
        return `${Math.round(num / 1e3)}K`;
        };

        return `${formatNumber(minImpressions)} ~ ${formatNumber(maxImpressions)}`;
      },
      ad_loops() {

        // Remove any non-numeric characters and parse as number
        const budget = parseFloat(this.stepThBudget.toString().replace(/[^\d.-]/g, ''));
        if (isNaN(budget) || budget <= 0) {
          return "-";
        }

        const countryCode = localStorage.getItem("country_code");
        let cost;

        if (countryCode === "EG") {
          cost = 0.65;
        } else if (countryCode.toLowerCase() === "sa") {
          cost = 0.6;
        } else {
          return "-"; // Invalid country code
        }

        const val = budget / cost;
        this.adLoop = val; // Store for minutes calculation

        // Format the values
        const formatNumber = (num) => {
          if (num >= 1000000) {
            return `${(num / 1000000).toFixed(1)} million`;
          } else if (num >= 1000) {
            return `${(num / 1000).toFixed(1)}K`;
          }
          return num.toFixed(0);
        };

        const min = formatNumber(Math.round((val * 0.8)));
        const max = formatNumber(Math.round((val * 1.2)));

        return `${min} ~ ${max}`;
      },

      minutes() {

        // Convert budget to number, ensuring it's a valid number
        const budget = parseFloat(this.stepThBudget);
        if (isNaN(budget) || budget <= 0) {
          return "-";
        }

        const countryCode = localStorage.getItem("country_code");
        let val;

        if (countryCode === "EG") {
          val = budget / 6;
        } else if (countryCode.toLowerCase() === "sa") {
          if (!this.adLoop || isNaN(this.adLoop)) {
            return "-";
          }
          val = this.adLoop * 0.5;
        } else {
          return "-"; // Invalid country code
        }

        if (isNaN(val) || val <= 0) {
          return "-";
        }

        // Format the values
        const formatNumber = (num) => {
          if (num >= 1000000) {
            return `${(num / 1000000).toFixed(1)} million`;
          } else if (num >= 1000) {
            return `${(num / 1000).toFixed(1)}K`;
          }
          return num.toFixed(0);
        };

        const min = formatNumber(Math.round(val * 0.8));
        const max = formatNumber(Math.round(val * 1.2));

        return `${min} ~ ${max}`;
      },
      Days(){
        if (!this.stepTh.duration.start || !this.stepTh.duration.end) {
          return "-";
        }
        try {
          const start = new Date(this.stepTh.duration.start);
          const end = new Date(this.stepTh.duration.end);

          // Normalize dates to the beginning of the day to avoid time issues
          start.setHours(0, 0, 0, 0);
          end.setHours(0, 0, 0, 0);

          // Check if dates are valid and end date is not before start date
          if (isNaN(start.getTime()) || isNaN(end.getTime()) || end < start) {
              return "-";
          }

          const diffTime = Math.abs(end - start);
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

          return diffDays + 1; // Add 1 for inclusive day count
        }
        catch (error) {
            return "-"; // Return '-' on error
        }
      },
      budget() {
        const startDate = this.stepTh.duration.start;
        const endDate = this.stepTh.duration.end;
        const diffInMilliseconds = new Date(endDate) - new Date(startDate);
        const diffInDays = Math.abs(diffInMilliseconds) / (1000 * 60 * 60 * 24);
        const days = Math.round(diffInDays);
        if (isNaN(days) || days <= 0 || this.stepTh.duration.start === null || this.stepTh.duration.end === null) {
          return "-";
        }
        return this.stepThBudget * diffInDays;
      },
      cars() {
        const budget = parseFloat(this.stepThBudget);
        if (isNaN(budget) || budget <= 0) {
          return "-";
        }
        const carsAssigned = Math.floor(budget / 36);
        return carsAssigned;
      }
    },
    methods: {
      markTouched(field) {
        this.touched[field] = true;
      },
      selectedGaolButton(goal) {
        this.stepOn.advertisingGoal = goal;
        this.$store.commit("setAdvertisingGoal", goal);
      },
      updateEndDate(event){
        const startDate = new Date(event);
        const newEndDateMinimum = new Date(startDate);
        newEndDateMinimum.setDate(startDate.getDate() + 1);
        this.endDateMinimum = newEndDateMinimum;

        if (this.stepTh.duration.end && new Date(this.stepTh.duration.end) < this.endDateMinimum) {
            this.stepTh.duration.end = null;
            this.touched.durationEnd = true;
        }
        this.endDateDisabled = false;
      },
      updateBudget(event){
        this.stepThBudget = `${36 * event.target.value}`;
      },
      updateCars(event){
        this.assignedCars = event.target.value / 36;
      },
      updateDuration(event){
        this.markTouched('durationStart');
        this.markTouched('durationEnd');
      },
      next() {
        this.touched = {
          advertisingGoal: true,
          campaignTitle: true,
          budget: true,
          durationStart: true,
          durationEnd: true
        };
        // Log local state before commit
        // console.log('CampaignInfo local stepOn before commit:', this.stepOn);

        // --> Add more detailed logs here
        // console.log('End Date Value:', this.stepTh.duration.end);
        // console.log('Is Duration Empty (computed):', this.emptyEndDate);
        // console.log('Is Form Valid (computed):', this.isFormValid);
        // <-- End of new logs

        if (this.isFormValid) {
          const duration = this.stepTh.duration
          const budget = this.stepThBudget
          const stepThree = {
            duration,
            budget
          }
          const expected = {
            expectedMinutes: this.minutes,
            expectedAdLoops: this.ad_loops,
            expectedImpressions: this.impressions,
          }
          // Commit step one data (including campaignTitle)
          this.$store.commit("updataStepO", this.stepOn);
          this.$store.commit("updataStepTH", stepThree);
          this.$store.commit("updateExpected", expected);
          this.$store.commit("setAssignedCars", this.assignedCars);
          // Proceed to the next step if all fields are valid
          this.$store.state.step = this.$store.state.step + 1;
        } else {
          console.log("Form invalid. Checks:", {
              advGoal: !this.emptyAdvertisingGoal,
              title: !this.emptyCampaignTitle,
              budget: !this.emptyBudget,
              endDate: !this.emptyEndDate,
          });
          window.scrollTo(0, 0);
        }
      },
      back() {
        if (this.$store.state.step > 1)
          this.$store.state.step = this.$store.state.step - 1;
        window.scrollTo(0, 0);
      },
    },
  };
  </script>
  <style>
  input[type="range"] {
    font-size: 1.5rem;
    width: 100%;
    border-radius: 20px;
  }

  input[type="range"] {
    color: #369da3;
    --thumb-height: 1.125em;
    --track-height: 0.4rem;
    --track-color: rgba(0, 0, 0, 0.2);
    --brightness-down: 80%;
    --clip-edges: 0.125em;
  }
  input[type="range"].win10-thumb {
    color: #2b2d42;

    --thumb-height: 1.375em;
    --thumb-width: 0.5em;
    --clip-edges: 0.0125em;
  }

  @media (prefers-color-scheme: dark) {
    html {
      background-color: #000;
    }

    html::before {
      background: radial-gradient(circle at center, #101112, #000);
    }

    input[type="range"] {
        --track-color: #f1f1f1;
    }

    input[type="range"].win10-thumb {
      color: #369da3;
    }
  }

  /* === range commons === */
  input[type="range"] {
    position: relative;
    background: #fff0;
    overflow: hidden;
  }

  input[type="range"]:active {
    cursor: grabbing;
  }

  input[type="range"]:disabled {
    filter: grayscale(1);
    opacity: 0.3;
    cursor: not-allowed;
  }

  /* === WebKit specific styles === */
  input[type="range"],
  .budget-range::-webkit-slider-runnable-track,
  .budget-range::-webkit-slider-thumb {
    -webkit-appearance: none;
    transition: all ease 100ms;
    height: var(--thumb-height);
  }

  .budget-range::-webkit-slider-runnable-track,
  .budget-range::-webkit-slider-thumb {
    position: relative;
  }

  .budget-range::-webkit-slider-thumb {
    --thumb-radius: calc((var(--thumb-height) * 0.5) - 1px);
    --clip-top: calc((var(--thumb-height) - var(--track-height)) * 0.5 - 0.5px);
    --clip-bottom: calc(var(--thumb-height) - var(--clip-top));
    --clip-further: calc(100% + 1px);
    --box-fill: calc(-100vmax - var(--thumb-width, var(--thumb-height))) 0 0
      100vmax currentColor;

    width: var(--thumb-width, var(--thumb-height));
    background: linear-gradient(currentColor 0 0) scroll no-repeat left center /
      50% calc(var(--track-height) + 1px);
    background-color: currentColor;
    box-shadow: var(--box-fill);
    /* border-radius: var(--thumb-width, var(--thumb-height)); */
    border-radius: 50px;

    filter: brightness(100%);
    clip-path: polygon(
      100% -1px,
      var(--clip-edges) -1px,
      0 var(--clip-top),
      -100vmax var(--clip-top),
      -100vmax var(--clip-bottom),
      0 var(--clip-bottom),
      var(--clip-edges) 100%,
      var(--clip-further) var(--clip-further)
    );
  }

  .budget-range:hover::-webkit-slider-thumb {
    filter: brightness(var(--brightness-hover));
    cursor: grab;
  }

  .budget-range:active::-webkit-slider-thumb {
    filter: brightness(var(--brightness-down));
    cursor: grabbing;
  }

  .budget-range::-webkit-slider-runnable-track {
    background: linear-gradient(var(--track-color) 0 0) scroll no-repeat center /
      100% calc(var(--track-height) + 1px);
  }

  .budget-range:disabled::-webkit-slider-thumb {
    cursor: not-allowed;
  }

  /* === Firefox specific styles === */
  .budget-range,
  .budget-range::-moz-range-track,
  .budget-range::-moz-range-thumb {
    appearance: none;
    transition: all ease 100ms;
    height: var(--thumb-height);
  }

  input[type="range"]::-moz-range-track,
  input[type="range"]::-moz-range-thumb,
  input[type="range"]::-moz-range-progress {
    background: #fff0;
  }

  input[type="range"]::-moz-range-thumb {
    background: currentColor;
    border: 0;
    width: var(--thumb-width, var(--thumb-height));
    /* border-radius: var(--thumb-width, var(--thumb-height)); */
    border-radius: 50px;
    cursor: grab;
  }

  input[type="range"]:active::-moz-range-thumb {
    cursor: grabbing;
  }

  input[type="range"]::-moz-range-track {
    width: 100%;
    background: var(--track-color);
  }

  input[type="range"]::-moz-range-progress {
    appearance: none;
    background: currentColor;
    transition-delay: 30ms;
  }

  input[type="range"]::-moz-range-track,
  input[type="range"]::-moz-range-progress {
    height: calc(var(--track-height) + 1px);
    border-radius: 50px;
  }

  input[type="range"]::-moz-range-thumb,
  input[type="range"]::-moz-range-progress {
    filter: brightness(100%);
  }

  input[type="range"]:hover::-moz-range-thumb,
  input[type="range"]:hover::-moz-range-progress {
    filter: brightness(var(--brightness-hover));
  }

  input[type="range"]:active::-moz-range-thumb,
  input[type="range"]:active::-moz-range-progress {
    filter: brightness(var(--brightness-down));
  }

  input[type="range"]:disabled::-moz-range-thumb {
    cursor: not-allowed;
  }
  </style>
